import { Link } from "react-router-dom"

const CourseCard = ({ course, showContinueButton = false }) => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL

  const imageSrc = `${course.image}`

  const renderStars = (rating) => {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(<i key={i} className={`fas fa-star ${i <= rating ? "text-warning" : "text-muted"}`}></i>)
    }
    return stars
  }


  return (
    <div className="course-card-vertical">
      <div className="course-image-container">
        <img
          src={imageSrc}
          alt={course.title}
          className="course-image-vertical"
        />
      </div>

      <div className="course-content-vertical">
        <div className="course-rating mb-2">
          <div className="stars me-2">{renderStars(course.rating)}</div>
          <span className="rating-value">
            {course.rating.toFixed(2)} {course.reviewCount && `(${course.reviewCount})`}
          </span>
        </div>

        <h5 className="course-title-vertical mb-3">{course.title}</h5>

        <div className="course-progress-info-vertical mb-3">
          <span className="progress-text">
            {course.completedLessons}/{course.totalLessons}
          </span>
          <span className="progress-percentage-vertical ms-auto">{course.progressPercentage}% Complete</span>
        </div>

        <div className="progress-section-vertical mb-3">
          <div className="progress custom-progress-vertical">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${course.progressPercentage}%` }}
              aria-valuenow={course.progressPercentage}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        {showContinueButton && (
          <Link to={`/course/${course.id}`} className="btn btn-outline-primary w-100 continue-btn">Continue Learning</Link>
        )}
      </div>
    </div>
  )
}

export default CourseCard
